import { FunctionComponent, ReactNode } from 'react';

// components
import { FormattedPrice } from './FormattedPrice';
import { priceLabel, discountLabel } from './messages/priceMessages';

import { PRICE_TYPES } from './constants';

// styles
import styles from './PriceAmount.scss';

// helpers
import classnames from 'classnames';

type Props = {
    amount?: number;
    currency: string;

    discount?: number;
    type?: string;
    hasNetPrice?: boolean;
    hasSalePrice?: boolean;
    hasPrivateOffer?: boolean;
    isUnavailable?: boolean;

    // options
    quantityDisplay: string | null;
    showLabel?: boolean;
    expiration?: ReactNode;
};

export const PriceAmount: FunctionComponent<Props> = ({
    amount = 0,
    currency,
    discount,
    hasNetPrice,
    hasSalePrice,
    hasPrivateOffer,
    quantityDisplay,
    showLabel,
    expiration,
    isUnavailable,
    type = PRICE_TYPES.RETAIL,
}) => {
    const className = classnames({
        [styles.retail]: type === PRICE_TYPES.RETAIL,
        [styles.net]: type === PRICE_TYPES.NET,
        [styles.hasNet]: hasNetPrice,
        [styles.hasSale]: hasSalePrice,
        [styles.hasPrivateOffer]: hasPrivateOffer,
        [styles.unavailable]: isUnavailable,
    });

    return (
        <>
            <div className={className} data-tn={`price-${type.toLowerCase()}`}>
                {/* Price */}
                <span className={styles.price} data-tn="price-amount">
                    <FormattedPrice value={amount} currency={currency} />
                </span>
                {/* List Price */}
                {showLabel && (
                    <span className={styles.label} data-tn="price-list-price">
                        {isUnavailable ? priceLabel(PRICE_TYPES.UNAVAILABLE) : priceLabel(type)}
                    </span>
                )}
                {/* Quantity */}
                {quantityDisplay && (
                    <span className={styles.label} data-tn="price-quantity-display">
                        {quantityDisplay}
                    </span>
                )}
                {/* Percent Off */}
                {discount && (
                    <span className={styles.discount} data-tn="price-discount">
                        {discountLabel(discount)}
                    </span>
                )}
            </div>
            {/* Expiration Date for Private Offers */}
            {expiration && (
                <span className={styles.expiration} data-tn="price-offer-expiration-date">
                    {expiration}
                </span>
            )}
        </>
    );
};
